'use client';
import { useEffect, useRef, useState } from 'react';
import { IPost } from '../../../models/ICategory';
import 'photoswipe/style.css';
import FallBackImage from '../../components/FallBackImage';
import { twMerge } from 'tailwind-merge';
import { isBrowser } from '../../../utils/isBrowser';

export default function ImageGallery({post, isInfographic}: {post: IPost; isInfographic: boolean;}) {
  const [mounted, setMounted] = useState(false);
  
  
  const [images, setImages] = useState<{src: string; thumbnail: string; alt?: string;}[]>([{src: post.image, thumbnail: post.thumbnail, alt: post.imageAlt}]);
  const galleryId = 'images-gallery';
  useEffect(() => {
    if (!isBrowser()) return;
    setMounted(true);
    setImages(prevState => [...prevState, ...extractImageSrcs(post.content)]);
    let lightbox: any;
    import('photoswipe/lightbox').then(({default: PhotoSwipeLightbox}) => {
      lightbox = new PhotoSwipeLightbox({
        gallery: '#' + galleryId,
        children: 'a',
        bgOpacity: 1,
        showAnimationDuration: 0,
        hideAnimationDuration: 0,
        imageClickAction: 'zoom',
        pswpModule: () => import('photoswipe'),
      });
      lightbox.init();
    });

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
  },[]);

  if (!mounted) return null;

  return (
    <div className="pswp-gallery desktop:!hidden" id={galleryId}>
      {images.map((x,i) => (
        <>
        <a
        className={twMerge('w-full h-fit block aspect-[16/9] relative', i >= 1 && 'hidden')}
        href={x.src}
        data-pswp-width={395}
        data-pswp-height={225}
        key={galleryId + '-' + i}
        id={galleryId + '-' + i}
        >
      <FallBackImage  customDimensions={{width: isInfographic ? 800 : 480}} src={x.src} alt={x.alt || x.src} fill eager={i===0} className={twMerge('h-full w-full object-cover')} />
        </a>
          </>
        ))}
    </div>
  )
}

function extractImageSrcs(html?: string) {
  if (!isBrowser() || !html) return [];
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  const imgElements = Array.from(tempDiv.getElementsByTagName('img'));

  const srcs = [];
  for (const img of imgElements) {
    if (img.src.endsWith('thumbnail')) continue;
    srcs.push({src: img.src, thumbnail: img.src});
  }

  tempDiv.remove();
  return srcs;
}